import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PickupRequesticon from '../../Icons/RunsheetIcon';
const RetunrOrderListComponent = loadable(
    () => import("../../components/ReturnOrders/ReturnOrderList")
  );
const ReturnOrdertList = () => {
  return (
    <>
    <div
    className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
  >   
    <PickupRequesticon/>
     <span className={tw`text-[#5E5757] font-bold text-xl`}>RTV/Return</span>
   
    </div>
     <RetunrOrderListComponent/>
     </>
  )
}

export default ReturnOrdertList
